import { Component, OnInit, OnDestroy, ViewChild, AfterViewInit} from '@angular/core';
import { MkmModel } from '../../../../models/mkm.model';
import { MkmService } from '../../../../services/mkm.service';
import { TzadikimService } from '../../../../services/tz.service';
import { NgForOf, NgIf } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { RouterModule, RouterOutlet } from '@angular/router';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { MatPaginator, MatPaginatorModule } from '@angular/material/paginator';

@Component({
    standalone:true,
    imports:[RouterOutlet,FormsModule,NgIf,NgForOf,MatTableModule,MatPaginatorModule, RouterModule],
    providers:[TzadikimService,MkmService],
    selector: 'mkm-index',
    templateUrl: './mkm-index.component.html',
    styleUrls: ['./mkm-index.component.css']
})

export class MkmIndexComponent implements AfterViewInit,OnInit {
    filter: string;
    displayedColumns: string[] = ['category', 'שטאט', 'נאמען', 'poi', 'actions'];
    dataSource = new MatTableDataSource<MkmModel>();
    allMkms!: MkmModel[];
    mkms!: MkmModel[];
    @ViewChild(MatPaginator) paginator: MatPaginator;
    constructor(private mkmService: MkmService, private tzadikimService: TzadikimService) { };

    ngOnInit(): void {
        
        this.dataSource.paginator = this.paginator;
        this.mkmService.getAllMkms().subscribe(m => {
            this.allMkms = m;
            this.dataSource.data = this.allMkms;
        });
     this.onSearch()
    }
    ngAfterViewInit() {
        this.dataSource.paginator = this.paginator;
      }
    onDelete(id: number) {

        this.tzadikimService.getTzMkmId(id).subscribe(t => {
            if (t.length) {

                alert("Can't delete state with city attached");
                return;
            }

            if (confirm("Are you sure?")) {
                this.mkmService.delete(id).subscribe(m => {
                    var i = this.mkms.findIndex(function (m) {
                        return m.id == id;
                    });

                    this.mkms.splice(i, 1);
                });
            }
        });
    }
    onSearch() {
        var mkms = this.allMkms;
        console.log('filter')
        if (this.filter) {
            mkms = mkms.filter(m => m.category.name.includes(this.filter)
                || m.city.cityY.includes(this.filter)
                || m.city.state.stateY.includes(this.filter)
                || m.mkmTitle.includes(this.filter)
                || m.poi.includes(this.filter));
        }

        this.dataSource.data = mkms;
    }
    onPoiClick(poi: string) {
        //console.log(poi);

        window.open('http://www.google.com/maps/search/?api=1&query=' + poi);
    }
}
